"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[148],{

/***/ 2260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_base_button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5500);
/* harmony import */ var _components_base_icon_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6653);




var ScrollDown = function() {
    var handleScrollDown = function() {
        window.scrollTo({
            top: window.innerHeight,
            behavior: 'smooth'
        });
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        onClick: handleScrollDown,
        className: "scroll-down",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_icon_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            name: "double-arrow"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ScrollDown);


/***/ }),

/***/ 8148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ slider_Slider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
// EXTERNAL MODULE: ./core/utils/index.ts + 2 modules
var utils = __webpack_require__(58);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 4 modules
var gridview = __webpack_require__(7923);
// EXTERNAL MODULE: ./components/base/image/Image.tsx
var Image = __webpack_require__(4297);
// EXTERNAL MODULE: ./components/widgets/scroll-down/ScrollDown.tsx
var ScrollDown = __webpack_require__(2260);
;// CONCATENATED MODULE: ./components/widgets/slider/Slider.tsx








function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Slider = function(param) {
    var data = param.data;
    var app = (0,contexts_app/* useApp */.qD)();
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "slider",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, _objectSpread({}, settings, {
                children: data === null || data === void 0 ? void 0 : data.map(function(item, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "item",
                            style: {
                                backgroundImage: "url(".concat(utils/* path.asset */.E.asset(app.environment, item.backgroundImage.src), ")")
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Container */.W2, {
                                size: "medium",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                                    xs: {
                                        align: 'center',
                                        justify: 'center'
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Column */.sg, {
                                        xs: {
                                            size: 12
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "title",
                                                children: [
                                                    item.title,
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: item.subTitle
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, _objectSpread({}, item.image, {
                                                    alt: item.title
                                                }))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: item.desc
                                                },
                                                className: "desc"
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }, index);
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollDown/* default */.Z, {})
        ]
    }));
};
/* harmony default export */ var slider_Slider = (Slider);

;// CONCATENATED MODULE: ./components/widgets/slider/index.ts



/***/ })

}]);